var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExpenses(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 30,
    viewBox: "0 0 25 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.727 29H1V1.07981C1 1.06944 1.00289 1.05927 1.00834 1.05045C1.01379 1.04163 1.02159 1.0345 1.03087 1.02986C1.04014 1.02522 1.05053 1.02326 1.06086 1.02419C1.07118 1.02512 1.08105 1.02891 1.08935 1.03513L3.38438 3.18499C3.39521 3.19196 3.40781 3.19567 3.42068 3.19567C3.43355 3.19567 3.44616 3.19196 3.45698 3.18499L5.29971 1.0128C5.30892 1.00456 5.32085 1 5.33321 1C5.34558 1 5.3575 1.00456 5.36672 1.0128L7.44398 3.19057C7.45451 3.19829 7.46722 3.20244 7.48028 3.20244C7.49333 3.20244 7.50604 3.19829 7.51657 3.19057L9.35372 1.01838C9.35841 1.01348 9.36405 1.00958 9.37029 1.00692C9.37652 1.00426 9.38324 1.00289 9.39002 1.00289C9.3968 1.00289 9.40351 1.00426 9.40975 1.00692C9.41599 1.00958 9.42162 1.01348 9.42632 1.01838L11.0234 3.1794C11.0344 3.18848 11.0482 3.19345 11.0624 3.19345C11.0767 3.19345 11.0905 3.18848 11.1015 3.1794L12.9219 1.01838C12.9266 1.01348 12.9322 1.00958 12.9385 1.00692C12.9447 1.00426 12.9514 1.00289 12.9582 1.00289C12.965 1.00289 12.9717 1.00426 12.978 1.00692C12.9842 1.00958 12.9898 1.01348 12.9945 1.01838L14.4966 3.17382C14.5071 3.18405 14.5211 3.18978 14.5357 3.18978C14.5503 3.18978 14.5644 3.18405 14.5748 3.17382L16.183 1.01838C16.1934 1.00815 16.2075 1.00242 16.2221 1.00242C16.2367 1.00242 16.2507 1.00815 16.2612 1.01838L17.8526 3.17382C17.8631 3.18405 17.8771 3.18978 17.8917 3.18978C17.9063 3.18978 17.9204 3.18405 17.9308 3.17382L19.4553 1.02955C19.4598 1.02264 19.4661 1.01697 19.4734 1.01305C19.4807 1.00913 19.4888 1.00707 19.4971 1.00707C19.5054 1.00707 19.5136 1.00913 19.5209 1.01305C19.5282 1.01697 19.5344 1.02264 19.539 1.02955L20.7954 3.17382C20.8059 3.18153 20.8187 3.18569 20.8317 3.18569C20.8448 3.18569 20.8575 3.18153 20.868 3.17382L23.66 1.0128C23.6687 1.00781 23.6785 1.00522 23.6884 1.0053C23.6984 1.00538 23.7082 1.00813 23.7167 1.01325C23.7253 1.01838 23.7323 1.02571 23.737 1.03446C23.7418 1.04322 23.7441 1.05309 23.7438 1.06305L23.727 29Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33887 21.1655H20.1924",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33887 24.6501H20.1924",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.72778 7.60205H11.04C12.3244 7.60205 13.7427 8.02644 13.7427 9.98085C13.7427 12.1028 11.9446 12.9125 10.0349 12.6947C10.0121 12.6926 9.9892 12.6976 9.96933 12.709C9.94946 12.7204 9.93357 12.7376 9.92382 12.7584C9.91407 12.7791 9.91092 12.8023 9.91481 12.8249C9.9187 12.8475 9.92944 12.8683 9.94556 12.8846L13.9996 17.2457",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2896 7.60205H10.7554",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.79492 10.0479H15.3231",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpenses);
export default __webpack_public_path__ + "static/media/expenses.d15746d26e724e84168c7c24a46a1be2.svg";
export { ForwardRef as ReactComponent };